<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('paymentAdjustment.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('paymentAdjustment.pageTitle'),
            href: '/payment-adjustments'
          },
          {
            text: $t('edit'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-6">
            <SearchInvoice
              @invoice="onReceiveInvoiceClick"
              ref="search_invoice"
            />
          </div>
          <div class="col-md-6">
            <FormV2
              v-model="model"
              ref="formV2"
              :validate="errors"
              :invoice="invoice"
            />
          </div>
        </div>
        <div class="row ts-mt-5">
          <div class="col-md-12">
            <h1 class="ts-text-lg ts-text-gray-600">
              {{ $t('paymentAdjustment.invoiceItem') }}
            </h1>
            <InvoiceItemDetail
              :validate="errors"
              v-model="model"
              ref="invoiceDetail"
            />
            <div class="validate" v-if="errors.has('inv_detail_list')">
              {{ errors.first('inv_detail_list') }}
            </div>
          </div>
        </div>
        <div class="row ts-mt-5">
          <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2">
            <ts-button @click="$router.push({ name: 'payment-adjustment' })">{{
              $t('cancel')
            }}</ts-button>
            <!-- <ts-button
              color="primary"
              :waiting="loading"
              @click.prevent="onUpdate"
              >{{ $t('update') }}</ts-button
            > -->
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>

    <a-modal
      width="50%"
      centered
      v-model="print_pdf"
      :title="$t('pdf')"
      :maskClosable="false"
      :footer="null"
      :zIndex="1020"
      @cancel="closePDFmodal"
    >
      <pdf-preview :src="src" :waiting="waiting" height="70vh" mspin="30vh" />
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import PdfPreview from './components/pdf_preview'
import SearchInvoice from './components/search-invoice.vue'
import FormV2 from './components/formV2.vue'
import InvoiceItemDetail from './components/invoice-item-detail.vue'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'invoiceAdjustmentEdit',
  components: {
    SearchInvoice,
    FormV2,
    InvoiceItemDetail,
    PdfPreview
  },
  data() {
    return {
      loading: false,
      errors: new Errors(),
      invoice: {},
      print_pdf: false,
      waiting: false,
      src: '',
      model: {
        adjustment_id: undefined,
        adj_date: moment().format('DD-MM-YYYY'),
        inv_id: null,
        new_inv_amount: 0,
        adj_amount: 0,
        next_payment_date: undefined,
        descriptions: '',
        new_class_id: '',
        inv_detail_list: [],
        bank_id: null,
        payment_method_id: 1,
        is_print: false
      }
    }
  },
  computed: {
    ...mapState('paymentAdjustment', ['edit_data'])
  },
  methods: {
    ...mapActions('paymentAdjustment', ['update', 'find']),
    onReceiveInvoiceClick(invoice) {
      this.invoice = invoice
      this.model.inv_id = invoice.inv_id
      this.$refs.invoiceDetail.fetchInvoiceDetail()
      this.$refs.formV2.fetchNewClass(this.invoice.acps_id)
    },
    onUpdate() {
      this.loading = true
      this.waiting = this.model.is_print
      this.print_pdf = this.model.is_print
      this.update({
        id: this.model.adjustment_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          if (this.model.is_print) {
            this.src = response.url
            this.clearInput()
          } else {
            this.$router.push({ name: 'payment-adjustment' })
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
          this.waiting = false
        })
    },
    clearInput() {
      this.model.adjustment_id = undefined
      this.model.adj_date = moment().format('DD-MM-YYYY')
      this.model.inv_id = null
      this.model.new_inv_amount = 0
      this.model.adj_amount = 0
      this.model.next_payment_date = undefined
      this.model.descriptions = ''
      this.model.new_class_id = ''
      this.model.inv_detail_list = []
      this.model.bank_id = null
      this.model.payment_method_id = 1
      this.model.is_print = false
    },
    closePDFmodal() {
      this.print_pdf = false
      this.src = null
    },
    fetchRecordById() {
      this.loading = true
      this.find(this.$route.params.id)
        .then(() => this.setData())
        .finally(() => (this.loading = false))
    },
    async setData() {
      await this.$refs.formV2
        .fetchNewClass(this.edit_data.academic_class.acp_id)
        .then(() => {
          return this.$refs.search_invoice.fetchInvoice(
            this.edit_data.invoice.inv_number
          )
        })
        .then(() => {
          this.invoice = this.$refs.search_invoice.invoices[0]
          this.assignDataToModel()
        })
        .then(() => {
          const acClass = this.$refs.formV2.classes.find(
            c => c.value == this.edit_data.class_id
          )
          let param = {
            ...acClass.obj,
            student_id: this.invoice.student_id
          }
          return this.$refs.invoiceDetail.fetchItemDetail(param)
        })
    },
    assignDataToModel() {
      this.model.adjustment_id = this.edit_data.adjustment_id
      this.model.adj_date = this.edit_data.adj_date
      this.model.inv_id = this.edit_data.inv_id
      this.model.new_inv_amount = this.edit_data.new_inv_amount
      this.model.adj_amount = this.edit_data.adj_amount
      this.model.next_payment_date = this.edit_data.next_payment_date
      this.model.descriptions = this.edit_data.descriptions
      this.model.new_class_id = this.edit_data.class_id
      this.model.bank_id = this.edit_data.bank_id
      this.model.student_id = this.edit_data.student_id
      this.model.payment_method_id = this.edit_data.payment_method_id
        ? this.edit_data.payment_method_id
        : 1
      this.model.is_print = false
      this.model.inv_detail_list = []
      this.edit_data.details.forEach(item => {
        this.model.inv_detail_list.push({
          old_fee_setup_id: item.old_fee_setup_id,
          fee_type_id: item.fee_type_id,
          fee_setup_id: item.fee_setup_id,
          old_fee_setup_name: item.fee_name_en,
          fee_description: item.fee_description,
          quantity: item.quantity,
          fee_start_date: item.fee_start_date,
          fee_end_date: item.fee_end_date,
          payment_term_id: item.payment_term_id,
          duration_in_month: item.duration_in_month,
          fee_amount: item.fee_amount,
          ac_term_id: item.ac_term_id,
          grade_id: item.grade_id,
          shift_id: item.shift_id,
          payment_term_name: item.payment_term_name,
          pro_type_id: item.pro_type_id
        })
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchRecordById()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('paymentAdjustment/SET_EDIT_DATA', undefined)
    next()
  }
}
</script>
